import React, {useContext, useState} from "react";
import "./Services.scss";
import {servicesSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

// Illustration from unDraw (open source) - programming/developer themed
const SERVICES_ILLUSTRATION_URL =
  "https://cdn.undraw.co/illustration/programming_j1zw.svg";

export default function Services() {
  const {isDark} = useContext(StyleContext);
  const [activeTab, setActiveTab] = useState(0);

  if (!servicesSection.display) {
    return null;
  }

  const {services} = servicesSection;
  const activeService = services[activeTab];

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="services">
        <div className="services-main-div">
          <Fade left duration={1000}>
            <div className="services-image-div">
              <img
                alt="Development services"
                src={SERVICES_ILLUSTRATION_URL}
              />
            </div>
          </Fade>
          <Fade right duration={1000}>
            <div className="services-content-div">
              <div className="services-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading services-heading"
                  : "heading services-heading"
              }
            >
              {servicesSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle services-subtitle"
                  : "subTitle services-subtitle"
              }
            >
              {servicesSection.subtitle}
            </p>
          </div>

          <div className="services-tabs-wrapper">
            <div
              className={
                isDark ? "dark-mode services-tabs" : "services-tabs"
              }
              role="tablist"
            >
              {services.map((service, i) => (
                <button
                  key={i}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === i}
                  aria-controls={`service-panel-${i}`}
                  id={`service-tab-${i}`}
                  className={`services-tab ${activeTab === i ? "services-tab--active" : ""} ${isDark ? "dark-mode" : ""}`}
                  onClick={() => setActiveTab(i)}
                >
                  <span className="services-tab-icon">{service.icon}</span>
                  <span className="services-tab-label">{service.title}</span>
                </button>
              ))}
            </div>

            <div
              className={
                isDark ? "dark-mode services-tab-panel" : "services-tab-panel"
              }
              id="service-panel-0"
              role="tabpanel"
              aria-labelledby={`service-tab-${activeTab}`}
            >
              <h3
                className={
                  isDark
                    ? "dark-mode services-tab-panel-title"
                    : "services-tab-panel-title"
                }
              >
                {activeService.title}
              </h3>
              <ul className="services-tab-panel-list">
                {activeService.description.map((line, i) => (
                  <li
                    key={i}
                    className={
                      isDark
                        ? "dark-mode services-tab-panel-item"
                        : "services-tab-panel-item"
                    }
                  >
                    {line}
                  </li>
                ))}
              </ul>
            </div>
            </div>
            </div>
          </Fade>
        </div>
      </div>
    </Fade>
  );
}
